import React from 'react';
import { HashRouter, Link, Navigate, NavLink, Route, Routes } from "react-router-dom";
import "./App.css";
import Hero from './sections/Hero';
import Timeline from './sections/Timeline';
import Skills from './sections/Skills';
import Toolbox from './sections/Toolbox';
import Projects from './sections/Projects';
import ThemeToggle from "./Components/ThemeToggle";
import Footer from "./sections/Footer";
import EnterpriseWork from "./sections/EnterpriseWork";
import FinalCta from "./sections/FinalCta";
import { APP_VERSION, APP_AUTHOR } from "./version";
import CvDownloadModal from "./Components/CvDownloadModal";

const navItems = [
  { label: "Home", path: "/" },
  { label: "Experience", path: "/experience" },
  { label: "Tools", path: "/tools" },
  { label: "Enterprise", path: "/enterprise" },
  { label: "Projects", path: "/projects" },
  { label: "Read This !", path: "/writing" },
  { label: "Contact", path: "/contact" },
];

export default function App() {
  const [cvModalOpen, setCvModalOpen] = React.useState(false);

  return (
    <HashRouter>
      <div className="App">
        <header className="topBar">
          <Link className="brandMark" to="/" aria-label="Hamza AIT-SIDI-SAID home">
            hamza
          </Link>

          <nav className="mainNav" aria-label="Primary navigation">
            {navItems.map((item) => (
              <NavLink
                key={item.path}
                to={item.path}
                className={({ isActive }) => (isActive ? "navLink isActive" : "navLink")}
                end={item.path === "/"}
              >
                {item.label}
              </NavLink>
            ))}
          </nav>

          <ThemeToggle />
        </header>

        <main className="sections">
          <Routes>
            <Route path="/" element={<Hero onDownloadCv={() => setCvModalOpen(true)} />} />
            <Route path="/experience" element={<Timeline onDownloadCv={() => setCvModalOpen(true)} />} />
            <Route path="/tools" element={<Toolbox />} />
            <Route path="/enterprise" element={<EnterpriseWork />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/writing" element={<Skills />} />
            <Route path="/contact" element={<FinalCta />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>

          <Footer version={APP_VERSION} author={APP_AUTHOR} />
        </main>

        <CvDownloadModal open={cvModalOpen} onClose={() => setCvModalOpen(false)} />
      </div>
    </HashRouter>
  );
}
